import { REDUX_MODEL_KEY } from '../../constants/key'
import {
  createISOStrDateUtil,
  mergeObjectUtil
} from 'packages/src'

export default function createReduxUtil (params) {
  const nowDate = createISOStrDateUtil()
  return mergeObjectUtil({
    [REDUX_MODEL_KEY.CLASS_NAME]: '',
    [REDUX_MODEL_KEY.CHANGED]: {},
    [REDUX_MODEL_KEY.DATA]: {},
    [REDUX_MODEL_KEY.VALIDATION]: null,
    [REDUX_MODEL_KEY.ERROR]: null,
    [REDUX_MODEL_KEY.STATUS]: null,
    [REDUX_MODEL_KEY.CREATED_AT]: nowDate,
    [REDUX_MODEL_KEY.UPDATED_AT]: nowDate,
    [REDUX_MODEL_KEY.VIEWED_AT]: null,
    [REDUX_MODEL_KEY.CID]: null
  }, params)
}
